<app-audit-subbar [deviceAware]="true"></app-audit-subbar>

<div class="tab-chip-container">
  <button
    class="tab-chip"
    [class.active]="selectedTab == 'ux'"
    (click)="selectedTab = 'ux'"
  >
    UX
  </button>
  <button
    class="tab-chip"
    [class.active]="selectedTab == 'cr'"
    (click)="selectedTab = 'cr'"
  >
    Conversion Readiness
  </button>
</div>

<app-ux *ngIf="selectedTab == 'ux'"></app-ux>
<app-cr *ngIf="selectedTab == 'cr'"></app-cr>
